<template>
  <t-vdxb-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
    <div class="t-vdxb-application-invite-user-upload__instruction">
      <a-vdxb-heading tag="h4">画像アップロード</a-vdxb-heading>
      <a-vdxb-text
        >必ずカラーでアップロードしてください。<br />STEP1の「契約情報の入力」で記入いただいた住所が確認できる書類をアップロードしてください。</a-vdxb-text
      >
    </div>
    <form v-if="show_form" class="t-vdxb-application-invite-user-upload__form" @submit.prevent="handleSubmitForm">
      <div class="t-vdxb-application-invite-user-upload__fields">
        <template v-for="(document, index) in formData.documents" :key="index">
          <!-- <m-form-input :label="'画像データ' + (index + 1)"> -->
          <m-form-input>
            <a-vdxb-select-field
              id="-uploadType"
              v-model="document.type"
              placeholder="書類の種類を選択してください"
              :options="documentTypeOptions"
              @change="handleChange"
            />
            <div class="t-vdxb-application-invite-user-upload__field-uploads">
              <div
                v-for="(image, imageIndex) in document.images"
                :id="'imgbox_' + imageIndex"
                :key="imageIndex"
                class="t-vdxb-application-invite-user-upload__field-uploads-col"
              >
                <a-vdxb-upload-field
                  v-model="image.file"
                  label="画像ファイルをアップロードしてください。"
                  accept="image/png, image/jpeg"
                  @change="handleUploadFileChange(index, imageIndex, image.file)"
                />
              </div>
            </div>
          </m-form-input>
        </template>
      </div>
      <div class="t-vdxb-application-invite-user-upload__buttons">
        <m-button-container>
          <!-- <a-vdxb-button variant="block" submit="submit" color="primary">次へ</a-vdxb-button> -->
          <a-vdxb-button id="next" variant="block" submit="submit" color="primary" :disabled="!agree"
            >次へ</a-vdxb-button
          >
          <a-vdxb-button id="back" color="primary" @click="handleCancelClick">戻る</a-vdxb-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-vdxb-modal
        v-model:visible="resultModalVisible"
        class="o-vdxb-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-vdxb-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-vdxb-text>
        <template #footer>
          <a-vdxb-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-vdxb-modal>
    </teleport>
  </t-vdxb-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TVdxbDefaultEntrySidebar from '@/components/templates/vdxb-default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
import AVdxbSelectField from '@/components/atoms/vdxb-select-field';
import AVdxbButton from '@/components/atoms/vdxb-button';
import MButtonContainer from '@/components/molecules/button-container';
import AVdxbUploadField from '@/components/atoms/vdxb-upload-field';
import AVdxbHeading from '@/components/atoms/vdxb-heading';
import AVdxbText from '@/components/atoms/vdxb-text';
import { IDENTIFICATION_OPTIONS } from '@/libs/constants';
import { cloneDeep } from 'lodash';
import OVdxbModal from '@/components/organisms/vdxb-modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { utils } from '@/common/utils.js';

import Loading from 'vue-loading-overlay';

export default {
  name: 't-vdxb-application-invite-user-upload',
  components: {
    TVdxbDefaultEntrySidebar,
    MFormInput,
    AVdxbSelectField,
    AVdxbButton,
    MButtonContainer,
    AVdxbUploadField,
    AVdxbHeading,
    AVdxbText,
    OVdxbModal,
    Loading,
  },
  mixins: [messageContent, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      sidebarInfo: {
        sidebarList: [
          { label: '契約情報の入力' },
          { label: '本人確認書類' },
          { label: '請求書送付先' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 2,
        heading: '本人確認書類',
        subHeading: 'Step 2',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      documentTypeOptions: IDENTIFICATION_OPTIONS,
      formData: {
        documents: [
          {
            type: null,
            images: [
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
              {
                file: null,
                filename: null,
                binary: null,
                size: null,
              },
            ],
          },
        ],
      },
      tmpCompanyID: '',
      tmpDate: '',
      dirname: '',
      agree: false,
      businessType: '',
      show_form: false,
      tmpUUID: '',
      tmpYMD: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      isLoading: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-application-invite-user-upload');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async mounted() {
    document.title = '本人確認書類 | COTOHA Voice DX Basic';

    utils.setMetaDescription(this.$route);
    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: '/vdxbsignup' });
      return; // #2314
    }

    try {
      this.tmpCompanyID = this.tmpUUID;
      this.tmpDate = this.tmpYMD;

      if (!this.tmpCompanyID || !this.tmpDate) {
        throw new Error('Invalid data.');
      }
      // this.tmpCompanyID = 'tmp_f63a8ae7-e674-444e-8771-73ca32e2641b';
      // this.tmpDate = '20210427';

      this.dirname = this.tmpCompanyID;

      const result = await this.getHistoryDoc(this.tmpCompanyID, this.tmpDate);

      if (result.businessType !== 'individual' && result.businessType !== 'company') {
        throw new Error('businessType: Invalid data.');
      }
      this.businessType = result.businessType;

      if (result.businessType === 'company') {
        this.sidebarInfo.sidebarList[0] = { label: '契約情報の入力' };
        this.sidebarInfo.sidebarList[1] = { label: '本人確認書類' };
        this.sidebarInfo.sidebarList[2] = { label: '契約情報の入力(法人)' };
        this.sidebarInfo.sidebarList[3] = { label: '法人の確認書類' };
        this.sidebarInfo.sidebarList[4] = { label: '請求書送付先' };
        this.sidebarInfo.sidebarList[5] = { label: 'お申し込み内容確認' };
      }
    } catch (error) {
      console.log(error);
      this.showErrorModal(messageContent.requireTry('情報取得'));
    }

    this.show_form = true;
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    async handleSubmitForm(e) {
      // e.preventDefault();
      const payload = cloneDeep(this.formData);
      this.handleFormSubmit(payload);

      try {
        // 暫定
        if (!this.formData.documents[0].images[0].binary && !this.formData.documents[0].images[1].binary) {
          this.showErrorModal(messageContent.requireUploadFileError);
          return;
        }

        // 入力チェック
        const type = this.formData.documents[0].type;
        if (type === IDENTIFICATION_OPTIONS[0].value) {
          // console.log('運転免許証');
          if (!this.formData.documents[0].images[0].binary || !this.formData.documents[0].images[1].binary) {
            this.showErrorModal(messageContent.alertDriverLicense('運転免許証'));
            return;
          }
        } else if (type === IDENTIFICATION_OPTIONS[1].value) {
          // console.log('マイナンバー');
          if (!this.formData.documents[0].images[0].binary) {
            this.showErrorModal(messageContent.alertIdentification('マイナンバー'));
            return;
          }
        } else {
          this.showErrorModal(messageContent.requireChoice('書類の種類'));
          return;
        }

        // ファイルサイズチェック
        for (let j = 0; j < 2; j++) {
          if (
            this.formData.documents[0].images[j].size !== null &&
            this.formData.documents[0].images[j].size > 10485760
          ) {
            this.showErrorModal(messageContent.alertUploadfileSizeExceeded(10));
            return;
          }

          if (this.formData.documents[0].images[j].filename !== null) {
            if (this.formData.documents[0].images[j].filename.length > 100) {
              this.showErrorModal(messageContent.alertUploadfileNameSizeExceeded(100));
              return;
            }
          }
        }

        // delete old upload file
        const result = await this.getCertificateDoc(this.tmpCompanyID, this.tmpDate);
        await this.deleteImage(result.DriverlicenseURL1);
        await this.deleteImage(result.DriverlicenseURL2);
        await this.deleteImage(result.MyNumberURL);
        // this.setCertificateDoc(this.tmpCompanyID, this.tmpDate, '', '', '', '');

        // #3627
        this.isLoading = true;
        // upload
        const url = new Map();
        for (let j = 0; j < 2; j++) {
          if (this.formData.documents[0].images[j].binary) {
            // ext
            const extList = this.formData.documents[0].images[j].filename.split('.');
            const ext = extList[extList.length - 1].toLowerCase();

            if (ext !== 'png' && ext !== 'jpeg' && ext !== 'jpg') {
              this.isLoading = false;
              this.showErrorModal(messageContent.requireChoice('画像ファイル'));
              return;
            }

            // filename
            let filename = '';
            if (type === IDENTIFICATION_OPTIONS[0].value) {
              const number = j + 1;
              filename = 'Driverlicense' + number;
            } else if (type === IDENTIFICATION_OPTIONS[1].value) {
              filename = 'MyNumber';
            }

            const result = await this.uploadImage(
              this.dirname + '/' + filename + '.' + ext,
              this.formData.documents[0].images[j].binary
            );

            if (result === 'error') {
              this.isLoading = false;
              this.showErrorModal(messageContent.requireChoice('画像ファイル'));
              return;
            }

            url.set(filename, result);
          }
        }

        const ret = await this.setCertificateDoc(
          this.tmpCompanyID,
          this.tmpDate,
          this.formData.documents[0].type,
          url.get('Driverlicense1'),
          url.get('Driverlicense2'),
          url.get('MyNumber')
        );

        if (ret === 'error') {
          throw new Error('/signup/setuploadfileinfo response was not ok.');
        }

        this.isLoading = false;
        if (this.businessType === 'individual') {
          this.$router.push({ name: 'VdxbSignupInvoice' });
        } else if (this.businessType === 'company') {
          this.$router.push({ name: 'VdxbSignupFormH' });
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.showErrorModal(messageContent.requireTry('ファイルのアップロード'));
      }
    },
    handleCancelClick() {
      this.$router.push({ name: 'VdxbSignupForm' });
    },
    handleUploadFileChange(documentIndex, imageIndex, file) {
      const vm = this;
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          const [info, content] = reader.result.split(',');
          vm.formData.documents[documentIndex].images[imageIndex].binary = content;
        },
        false
      );

      const type = this.formData.documents[0].type;

      if (file[0]) {
        reader.readAsDataURL(file[0]);
        vm.formData.documents[documentIndex].images[imageIndex].filename = file[0].name;
        vm.formData.documents[documentIndex].images[imageIndex].size = file[0].size;

        if (
          type === 'driver_license' &&
          vm.formData.documents[documentIndex].images[0].filename !== null &&
          vm.formData.documents[documentIndex].images[1].filename !== null
        ) {
          vm.agree = true;
        } else if (type === 'my_number_card' && vm.formData.documents[documentIndex].images[0].filename !== null) {
          vm.agree = true;
        }
      } else {
        // clear file content
        vm.formData.documents[documentIndex].images[imageIndex].file = null;
        vm.formData.documents[documentIndex].images[imageIndex].filename = null;
        vm.formData.documents[documentIndex].images[imageIndex].binary = null;
        vm.formData.documents[documentIndex].images[imageIndex].size = null;

        if (
          type === 'driver_license' &&
          (vm.formData.documents[documentIndex].images[0].filename === null ||
            vm.formData.documents[documentIndex].images[1].filename === null)
        ) {
          vm.agree = false;
        } else if (type === 'my_number_card' && vm.formData.documents[documentIndex].images[0].filename === null) {
          vm.agree = false;
        }

        //        if (!this.formData.documents[0].images[0].binary && !this.formData.documents[0].images[1].binary) {
        //          vm.agree = false;
        //        }
      }
    },
    uploadImage(path, binary) {
      const format = this.getFileFormat(binary);

      if (format === 'unknown') {
        return 'error';
      }

      return this.postRequest('/signup/uploaddocument', {
        path: path,
        binary: binary,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/uploaddocument response was not ok.');
        }
        return e.result;
      });
    },
    deleteImage(path) {
      if (!path) {
        return false;
      }
      return this.postRequest('/signup/deletedocument', {
        path: path,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/deletedocument response was not ok.');
        }
        return e.result;
      });
    },
    setCertificateDoc(tmpCompanyID, date, certificateType, driverlicenseURL1, driverlicenseURL2, mynumberURL) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        certificateType: certificateType,
        driverlicenseURL1: driverlicenseURL1,
        driverlicenseURL2: driverlicenseURL2,
        mynumberURL: mynumberURL,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/setuploadfileinfo', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/setuploadfileinfo response was not ok.');
            }

            return e.result;
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          return 'error';
        });
    },
    getCertificateDoc(tmpCompanyID, date) {
      return this.postRequest('/signup/getcertificatedoc', {
        tmpCompanyID: tmpCompanyID,
        date: date,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/signup/getcertificatedoc response was not ok.');
        }
        return e.result;
      });
    },
    getHistoryDoc(tmpCompanyID, date) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/gethistorydoc', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/gethistorydoc response was not ok.');
            }
            return e.result;
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    handleChange() {
      const type = this.formData.documents[0].type;

      this.agree = false;
      if (
        type === 'driver_license' &&
        this.formData.documents[0].images[0].filename !== null &&
        this.formData.documents[0].images[1].filename !== null
      ) {
        this.agree = true;
      } else if (type === 'my_number_card' && this.formData.documents[0].images[0].filename !== null) {
        this.agree = true;
      }

      document.getElementById('imgbox_0').style.display = 'block';
      document.getElementById('imgbox_1').style.display = 'block';
      if (type === 'my_number_card') {
        document.getElementById('imgbox_1').style.display = 'none';
      }
    },
    getFileFormat(binary) {
      const string_of_binary = atob(binary);
      const ary = [];
      let header = '';

      for (let i = 0; i < 4; i++) {
        ary[i] = string_of_binary.charCodeAt(i);
        header += ary[i].toString(16);
      }

      switch (true) {
        case /^89504e47/.test(header):
          return 'image/png';
        case /^ffd8ff/.test(header):
          return 'image/jpeg';
        default:
          return 'unknown';
      }
    },
  },
};
</script>
